import { render, staticRenderFns } from "./LrPlusBenefits.vue?vue&type=template&id=222f072e&"
import script from "./LrPlusBenefits.vue?vue&type=script&lang=js&"
export * from "./LrPlusBenefits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\LRGithub\\lr-statics\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('222f072e')) {
      api.createRecord('222f072e', component.options)
    } else {
      api.reload('222f072e', component.options)
    }
    module.hot.accept("./LrPlusBenefits.vue?vue&type=template&id=222f072e&", function () {
      api.rerender('222f072e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lr/js/vue/components/lr-plus-benefits/LrPlusBenefits.vue"
export default component.exports